import React, { useState, useEffect } from 'react';

/* MUI */
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from '@material-ui/core';

import FormInputTypography from '../../form-input/form-input-typography.component.jsx';


const LegalOwnerAppeal = (props) => {
  const [data, setData] = useState({
    customerAppealId: "",
    new_legal_owner_name: "",
    appeal_record_date: "",
    phone_number: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    country: "USA",
    applicant_comments: "",
    isGovernmentEntity: false
  });

  useEffect(() => {
    if (props.data) {
      setData(props.data);
    }
  }, [props.data])

  return (
    <Accordion expanded>
      <AccordionSummary id="incorrectOwnerAppeal" style={{ backgroundColor: "whitesmoke" }}>
        <Typography variant="h6" align="center" gutterBottom color="primary">
          Information for Incorrect Owner Appeal
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body1" color="textSecondary">
              The property owner listed above no longer owns the parcel in question.
              Customer does not own the assessor block lot for which they are being billed.
            </Typography>
          </Grid>
          {/* <Grid item xs={12}>
            <Typography variant="h6" color="error">
              There is a CURRENT APPEAL PENDING. Please contact us at ZZZ-ZZZ-ZZZZ before submitting a new request.
            </Typography>
          </Grid> */}
          <FormInputTypography
            label="Incorrect Owner Appeal ID"
            size={5}
            value={data.customerAppealId}
          />
          <FormInputTypography
            label="Appealed Legal Owner Name"
            size={5}
            value={data.new_legal_owner_name}
          />
          <FormInputTypography
            label="Record Date"
            size={5}
            value={data.appeal_record_date}
          />
          <FormInputTypography
            label="Phone Number"
            size={5}
            value={data.phone_number}
          />
          <FormInputTypography
            label="New Owner Mailing Address"
            size={5}
            value={data.address}
          />
          <FormInputTypography
            label="New Owner Mailing Address 2"
            size={5}
            value={data.address2}
          />
          <FormInputTypography
            label="New Owner Mailing City"
            size={5}
            value={data.city}
          />
          <FormInputTypography
            label="New Owner Mailing State"
            size={5}
            value={data.state}
          />
          <FormInputTypography
            label="New Owner Mailing Zipcode"
            size={5}
            value={data.zip}
          />
          <FormInputTypography
            label="New Owner Mailing Country"
            size={5}
            value={data.country}
          />
          <FormInputTypography
            label="Is Government Entity"
            size={5}
            value={data.isGovernmentEntity ? 'Yes' : 'No'}
          />
          <FormInputTypography
            label="Applicant Comments"
            size={5}
            value={data?.applicant_comments ? data.applicant_comments: ""}
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
}

export default LegalOwnerAppeal;